import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

export const TopNavColumn = forwardRef((props, ref) => {
  const { as = 'div', style, children, ...rest } = props
  const Comp = as
  return (
    <Comp
      className="dev_dash__top-nav-column"
      style={style}
      ref={ref}
      {...rest}
    >
      {children}
    </Comp>
  )
})

TopNavColumn.displayName = 'TopNavColumn'

TopNavColumn.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
}
